import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.veranstaltung-logo-aktualisieren';
import * as api from '../../../clients/veranstaltungen';

@Injectable()
export class VeranstaltungenVeranstaltungLogoAktualisierenEffects {

    VeranstaltungLogoAktualisieren$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_VERANSTALTUNG_LOGO_AKTUALISIEREN),
        mergeMap((x: ac.PostVeranstaltungLogoAktualisierenAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postVeranstaltungLogoAktualisieren(x.veranstaltungLogoAktualisierenRequest).pipe(
                map((result: any) => {
                    return new ac.PostVeranstaltungLogoAktualisierenErfolgreichAction(result, x.veranstaltungLogoAktualisierenRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostVeranstaltungLogoAktualisierenFehlerAction(error, x.veranstaltungLogoAktualisierenRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.AdminCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.AdminCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.AdminCommandService);
        }
        return this.service;
    }
}
